import getWindow from "./getWindow.js";
export default function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/dom-utils/getComputedStyle.js
// module id = 196
// module chunks = 22